"use strict";
/**
 * 使用crypto.js 进行加密解密
 * 插件不兼容安卓5
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptDataFn = exports.encryptDataFn = void 0;
/**
 * 三种情况 条件：1. 弹窗visible=true ，2.在58app
 * 1. 初始化的时候获取用户信息手机号 - 调用接口 （如无数据则不需要调用）
 * 2. 信息填写完成，未勾选隐私协议的时候 - 调用接口（数据使用当前填写的数据）
 * 3. 提交成功调用旧接口增加字段
 */
var crypto_js_1 = __importDefault(require("crypto-js"));
/** 密钥 前后端定义一致 ##不能随意修改## 每个业务线key不同 */
var defaultSecretKey = 'oYCMyuHVQRGTWadK';
/**
 * 加密方法
 * @param data -- 需要加密的数据
 * @param secretKey -- 加密的key 随业务线不同
 *
 */
var encryptDataFn = function (data, secretKey) {
    var text = JSON.stringify(data);
    text = crypto_js_1.default.enc.Utf8.parse(text);
    // 为了避免补位 使用16位的密钥
    var key = crypto_js_1.default.enc.Utf8.parse(secretKey || defaultSecretKey);
    var encrypted = crypto_js_1.default.AES.encrypt(text, key, {
        mode: crypto_js_1.default.mode.ECB,
        padding: crypto_js_1.default.pad.Pkcs7,
    });
    return crypto_js_1.default.enc.Base64.stringify(crypto_js_1.default.enc.Utf8.parse(encrypted)).toString();
};
exports.encryptDataFn = encryptDataFn;
/**
 * 解密
 * @param data
 */
var decryptDataFn = function (data, secretKey) {
    var encrypted = crypto_js_1.default.enc.Utf8.stringify(crypto_js_1.default.enc.Base64.parse(data)).toString();
    var key = crypto_js_1.default.enc.Utf8.parse(secretKey || defaultSecretKey);
    var decrypted = crypto_js_1.default.AES.decrypt(encrypted, key, {
        mode: crypto_js_1.default.mode.ECB,
        padding: crypto_js_1.default.pad.Pkcs7,
    });
    return crypto_js_1.default.enc.Utf8.stringify(decrypted).toString();
};
exports.decryptDataFn = decryptDataFn;
